import { Login } from '../../molecules/Login/Login';

export default function LoginOrganism(): JSX.Element {
  return (
    <>
      <Login />
    </>
  );
}
